export default "__VITE_ASSET__B5QXCt0S__"